module.exports = __webpack_public_path__ + "static/media/Oral_health.2972cf9e.png";